import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Carousel from "react-bootstrap/Carousel";
import CloseIcon from "@heroicons/react/solid/XIcon";
import Image from "next/image";

const ZoomModal = (props) => {
  const { show, setShow, medias, productName } = props;

  return (
    <Modal
      show={show}
      fullscreen={true}
      onHide={() => {
        setShow(false);
      }}
    >
      <Modal.Header>
        <Modal.Title>Gallery</Modal.Title>
        <Button
          variant="link"
          className="text-dark"
          onClick={() => {
            setShow(false);
          }}
        >
          <CloseIcon height="20px" width="20px" />
        </Button>
      </Modal.Header>

      <Modal.Body className="w-100 h-100 bg-dark">
        <Carousel  className="h-100 w-100">
          {medias.map((row, index) => (
            <Carousel.Item key={index} className="w-100 h-100">
              <div className="d-flex align-items-center justify-content-center h-100">
                <Image
                  src={row.media_file.sizes.large}
                  alt={productName}
                  layout="fill"
                  objectFit="contain"
                  placeholder="blur"
                  blurDataURL={row.media_file.sizes.large}
                  unoptimized
                />
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </Modal.Body>
    </Modal>
  );
};

export default ZoomModal;
